import { useStoreActions } from '~/contexts';
import { isTransientError } from '~/hooks/isTransientError';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
const MAX_RETRY_DELAY_MS = 8000;
export const useRegisterMobileNotification = ()=>{
    const { api } = useStoreActions();
    const { mutate, isLoading, isError } = useMutationState({
        mutationFn: (info)=>api.mobileNotification.register(info),
        retry: (failureCount, error)=>failureCount < 3 && isTransientError(error),
        retryDelay: (attempt)=>Math.min(1000 * 2 ** attempt, MAX_RETRY_DELAY_MS)
    });
    return {
        registerMobileNotification: mutate,
        isLoading,
        isError
    };
};
